import { FeedConfigBar } from "./FeedConfigBar";

export default FeedConfigBar;
